import {
    GESTION_OPERATIVA_GET_SALE,
    GESTION_OPERATIVA_GET_SALE_DISMISS_ERROR,
  } from '../constants'

  export function getSale(id, queryData, perfil, editMode = false) {
    console.log('THIS IS THE QUERY DATA FROM HISTORY', queryData)
    return  (dispatch) => {
      // optionally you can have getState as the second argument

      dispatch({
        type: GESTION_OPERATIVA_GET_SALE,
        data: {id, queryData, perfil, editMode}
      })
    }
  }

  export function dismissGetSaleError() {
    return {
      type: GESTION_OPERATIVA_GET_SALE_DISMISS_ERROR,
    }
  }